import type { FC } from "react";
import Metadata from "~/components/metadata";
import PrivacyPolicy from "~/components/privacy-policy";

const PrivacyPolicyPage: FC = () => (
  <>
    <Metadata
      pageTitle="Advante Privacy Policy"
      title="Privacy Policy"
      description="Privacy Policy"
      canonical="https://advante.co/privacy-policy"
    />
    <PrivacyPolicy />
  </>
);

export default PrivacyPolicyPage;
